/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * API
 * OpenAPI spec version: 1.0.0
 */

export type GetApiDirectWebstorePayments200DataItemRefundStatus =
    (typeof GetApiDirectWebstorePayments200DataItemRefundStatus)[keyof typeof GetApiDirectWebstorePayments200DataItemRefundStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetApiDirectWebstorePayments200DataItemRefundStatus = {
    PAID: 'PAID',
    PARTIALLY_REFUNDED: 'PARTIALLY_REFUNDED',
    REFUNDED: 'REFUNDED',
} as const;
